<template>
  <v-card>
    <v-card-title primary-title style="margin: 0;padding: 0 5px;">
      <v-subheader>配置数据来源</v-subheader>
    </v-card-title>
    <v-container grid-list-md fluid>
      <v-layout column>
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 lg4 xl3 v-for="item in Props" :key="item.value">
            <gh-prop-view :model="model" :prop="item"></gh-prop-view>
          </v-flex>
        </v-layout>
      </v-layout>
      <gh-code-editor title="数据来源" :show-actions="true" v-model="model.source"
        :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'python'}" @submit='' @cancel=''>
        <template #actions>
          <div></div>
        </template>
      </gh-code-editor>
      <!-- <v-textarea v-model="model.source" outline :label="dic.source.text" auto-grow></v-textarea> -->

    </v-container>
  </v-card>
</template>

<style scoped>

</style>

<script>
  import SelectionPropertys from "./selectionPropertys.ts";
  export default SelectionPropertys;
</script>